import { Component, Output, EventEmitter, signal } from '@angular/core';
import { MenuService } from './menu.service';

import { TranslatePipe, TranslateService } from '@ngx-translate/core';

import { AccordionDirective, AccordionLinkDirective, AccordionAnchorDirective } from '../menu-accordion';
import { Router, RouterLink } from '@angular/router';

/* tslint:disable:max-line-length */
@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    standalone: true,
    imports: [TranslatePipe, RouterLink, AccordionDirective, AccordionLinkDirective, AccordionAnchorDirective]
})
export class MenuComponent {
  currentLang = 'en';
  menuItems = signal<any[]>([]);
  
  @Output() menuItemClicked = new EventEmitter<void>();
  
  constructor(
    public menuService: MenuService,
    public translate: TranslateService,
    private router: Router
  ) {
    this.menuItems.set(menuService.getAll());
  }
  
  /**
   * Check if the given route is active
   * This helps with applying the active class to menu items
   */
  isActive(route: string): boolean {
    // Check if current URL starts with this route
    return this.router.url === route || this.router.url.startsWith(route + '/');
  }
  
  /**
   * Handle menu item click events. The layout owns the breakpoint and decides
   * whether the click should close the drawer, so this just reports the click.
   */
  onMenuItemClick(event: MouseEvent, isExternal: boolean = false): void {
    if (!isExternal) {
      this.menuItemClicked.emit();
    }
  }
}
